import moment from 'moment'

export const HISTORY_PAGE_SIZE = 20
export const IMAGE_RETENTION_DAYS = 90
export const DATE_FORMAT = 'DD/MM/YYYY'
export const QUERY_DATE_FORMAT = 'YYYY-MM-DD'
export const DATETIME_FORMAT = 'HH:mm DD/MM/YYYY'

// Mặc định 7 ngày gần nhất (theo mockup).
export const getDefaultFilters = () => ({
    from: moment().subtract(6, 'days').format(QUERY_DATE_FORMAT),
    to: moment().format(QUERY_DATE_FORMAT),
    partner: '',
    handed_by: '',
    batch_name: '',
})

// filters.partner là chuỗi id nối dấu phẩy để URL giữ dạng string, link cũ ?partner=<id> vẫn hợp lệ.
export const toPartnerIds = (value) => `${value || ''}`.split(',').map(id => id.trim()).filter(Boolean)

export const formatDateTime = (value) => value ? moment(value).format(DATETIME_FORMAT) : '—'

// S3 lifecycle xoá ảnh sau IMAGE_RETENTION_DAYS ngày; BE trả image_expired, FE tự tính khi không có cờ.
export const isHandoverImageExpired = (handedAt) => {
    if (!handedAt) return false
    return moment(handedAt).add(IMAGE_RETENTION_DAYS, 'days').isBefore(moment())
}

const SOURCE_LABEL = {
    qr: 'QR',
    manual: 'Nhập tay',
    edited: 'Sửa tay',
}

export const getSourceLabel = (batch) => {
    const { source } = batch || {}
    return SOURCE_LABEL[source] || source || '—'
}
